import ProductAccessoryCard from './ProductAccessoryCard';

export default ProductAccessoryCard;
